/** Lo mínimo de `navigator` que mira la detección (así se puede testear sin tocar el global). */
export interface DeviceInfo {
  userAgent: string;
  maxTouchPoints?: number;
  userAgentData?: { mobile?: boolean };
}

/**
 * ¿Es un celular o una tablet (Android, iPhone, iPad)? Windows, Mac y Linux/ChromeOS son desktop.
 *
 * La PWA instalada solo muestra la landing en estos dispositivos; en desktop se instala la
 * plataforma completa. Va por varias señales porque ninguna alcanza sola:
 *  - `userAgentData.mobile`: lo más confiable en Chromium (Android), pero no existe en Safari/Firefox.
 *  - El user agent: cubre Android (también tablets, que no dicen "Mobile"), iPhone/iPod/iPad.
 *  - iPadOS 13+ se presenta como "Macintosh": lo delata la pantalla táctil (una Mac no tiene).
 */
export function isMobileDevice(device: DeviceInfo): boolean {
  if (device.userAgentData?.mobile === true) return true;
  if (/Android|iPhone|iPod|iPad|Mobile|Windows Phone|webOS|BlackBerry/i.test(device.userAgent)) return true;
  if (/Macintosh/i.test(device.userAgent) && (device.maxTouchPoints ?? 0) > 1) return true;
  return false;
}

export function isMobileDeviceNow(): boolean {
  if (typeof navigator === 'undefined') return false;
  return isMobileDevice(navigator as unknown as DeviceInfo);
}

/**
 * ¿Es un CELULAR (no una tablet)? Es lo que decide si la web se bloquea con la landing "Instalá la app": las tablets (iPad, tablets
 * Android) siguen usando la plataforma completa.
 *  - `userAgentData.mobile` (Chromium): `true` en celulares y `false` en tablets Android.
 *  - Android: los celulares dicen "Mobile" en el user agent y las tablets no.
 *  - iPhone/iPod son celulares; un iPad moderno se presenta como "Macintosh" y por eso no entra acá.
 */
export function isPhoneDevice(device: DeviceInfo): boolean {
  if (device.userAgentData?.mobile === true) return true;
  const ua = device.userAgent;
  if (/iPhone|iPod|Windows Phone|BlackBerry|webOS/i.test(ua)) return true;
  if (/Android/i.test(ua) && /Mobile/i.test(ua)) return true;
  return false;
}

export function isPhoneDeviceNow(): boolean {
  if (typeof navigator === 'undefined') return false;
  return isPhoneDevice(navigator as unknown as DeviceInfo);
}
